import { call, select } from 'redux-saga/effects';
import { selectContentLibraryOpenedFile } from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { isContentLibraryMediaPlayer } from 'features/content-library/utils/isContentLibraryMediaPlayer';
import { selectGridPanelCollapsed } from 'features/layout/features/content/contentSlice';

/**
 * No-op for media-player files.
 *
 * The player entry is intentionally kept alive across layout cascades;
 * the live broadcast stream is the source of truth.
 * Selectors stay for parity — delete in a follow-up if no media-player path remains.
 */
export function* onStreamMaximizedSaga() {
  const gridPanelCollapsed: boolean = yield select(selectGridPanelCollapsed);
  const openedFile: ContentLibraryOpenedFile | null = yield select(selectContentLibraryOpenedFile);

  if (!gridPanelCollapsed || !openedFile) {
    return;
  }

  yield call(isContentLibraryMediaPlayer, openedFile);
  // Intentionally no action regardless of file type. See JSDoc above.
}
